import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';
import { IoIosArrowBack } from 'react-icons/io';
import { LayeredRulingContext } from '@/features/editor/widgets/custom-widget/loading-section/layered-ruling/context';
import { SearchHeader } from '@/features/editor/widgets/custom-widget/loading-section/shared/search-header';
import { ManualImageSelectHeaderInner } from '@/features/editor/widgets/custom-widget/loading-section/shared/manual-image-select';
import { ADD_ANOTHER_RULE_ANCHOR_ID } from '@/features/editor/widgets/custom-widget/loading-section/layered-ruling/rules';

const scrollToBottom = () => {
  document
    .getElementById(ADD_ANOTHER_RULE_ANCHOR_ID)
    ?.scrollIntoView({ behavior: `smooth`, block: `end` });
};

export function Header() {
  const ctx = useContext(LayeredRulingContext);
  if (ctx.isManualImageSelectionOpen) {
    return (
      <ManualImageSelectHeaderInner
        onBack={() => ctx.setManualImageSelectionOpen(undefined)}
      />
    );
  }
  if (ctx.isProductSearchOpen) {
    return (
      <SearchHeader
        onBack={() => ctx.setProductSearchSlotOpen(undefined)}
        value={ctx.searchState.searchText}
        onChange={(e) => {
          ctx.setSearchText(e.target.value);
        }}
      />
    );
  }
  if (ctx.state.showCondBuilder || ctx.isGlobalFilterOpen) {
    const num = useMemo(
      () =>
        ctx.state.rules
          ?.find((r) => r.isOpen)
          ?.strategyPerSlot?.slots?.findIndex(
            (s) => s.num === ctx.state.activeCondSlot,
          ),
      [],
    );
    return (
      <MoreFiltersWrapper>
        <Back
          type="button"
          onClick={() =>
            ctx.isGlobalFilterOpen
              ? ctx.setIsGlobalFilterOpen(false)
              : ctx.toggleCondBuilder()
          }
        >
          <IoIosArrowBack color="grey" size={40} />
        </Back>
        <FilterDesc>
          {ctx.isGlobalFilterOpen ? (
            <>
              <p>Add Global Filter</p>
              <div>
                Global filters apply to all slots and update automatically
                across them
              </div>
            </>
          ) : (
            <>
              <p>
                {num >= 0
                  ? `Extra Filters for Slot ${num + 1}`
                  : `More Filters`}
              </p>
              {ctx.isGlobalFilterApplied && (
                <div>
                  Please note: Global filters are applied. Any additional filter
                  you add will apply only to this slot
                </div>
              )}
            </>
          )}
        </FilterDesc>
      </MoreFiltersWrapper>
    );
  }
  return (
    <Wrapper>
      <p>Advanced Ruling</p>
      <span>
        Set distinct strategies according to specific rules, listed by priority.
      </span>
      <AddRuleLink type="button" onClick={scrollToBottom}>
        + Add Rule
      </AddRuleLink>
    </Wrapper>
  );
}

const Back = styled.button`
  &:hover {
    cursor: pointer;
    opacity: 0.3;
  }
  &:active {
    cursor: pointer;
    opacity: 0.5;
  }
  opacity: 0.5;
  left: -4rem;
  position: absolute;
  top: -2.8rem;
  color: #efefef;
`;

const MoreFiltersWrapper = styled.div`
  position: relative;
  width: 90%;
  user-select: none;
  border-bottom: 3px #f5f5f5 solid;
  margin: 0 4rem;
  padding-bottom: 2rem;
  p {
    font-size: 3rem;
    margin: -3rem 0 1rem 0;
  }
`;

const Wrapper = styled.div`
  margin: -2.5rem;

  p {
    font-size: 3rem;
    margin: 0 0 1rem 0;
  }
  span {
    font-size: 1.6rem;
    font-weight: normal;
  }
`;

const AddRuleLink = styled.button`
  display: block;
  margin: 2rem auto 0;
  padding: 0;
  background: none;
  border: none;
  font-family: Inter, serif;
  font-size: 1.4rem;
  font-weight: 600;
  color: #000000;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    opacity: 0.6;
  }
  &:active {
    opacity: 1;
  }
`;

const FilterDesc = styled.div`
  p {
    font-size: 3rem;
    margin: -2.5rem 0 1rem 0;
  }

  div {
    background: #f5f5f5;
    text-align: left;
    padding: 1.3rem 3rem;
    font-size: 1.5rem;
    font-weight: 400;
    border-radius: 10px;
    margin-top: 2rem;
  }
`;
